// Monta o AuthState a partir do Supabase e leva o usuário ao passo certo.
import { supabase } from "./supabase";
import { type AuthState, nextStep, type Step, stepAllowed } from "./routes";

function level(v: string | null | undefined): "aal1" | "aal2" | null {
  return v === "aal1" || v === "aal2" ? v : null;
}

/** Usuário criado por convite de operador (inviteUserByEmail com data.invitation_id). */
export function isInvitee(meta: Record<string, unknown> | undefined): boolean {
  return typeof meta?.invitation_id === "string";
}

export async function loadAuthState(): Promise<AuthState> {
  const { data } = await supabase.auth.getSession();
  const user = data.session?.user;
  if (!user) {
    return { signedIn: false, emailConfirmed: false, currentLevel: null, nextLevel: null, isAdmin: false, needsPassword: false, invited: false };
  }
  const { data: aal } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  return {
    signedIn: true,
    emailConfirmed: Boolean(user.email_confirmed_at),
    currentLevel: level(aal?.currentLevel),
    nextLevel: level(aal?.nextLevel),
    // Só app_metadata: user_metadata é editável pelo próprio usuário.
    isAdmin: user.app_metadata?.role === "admin",
    // Dica de tela para o convite (passo set-password). Editável pelo usuário, então
    // nunca decide acesso: no máximo leva a pessoa para a página de definir senha.
    needsPassword: isInvitee(user.user_metadata) && user.user_metadata?.password_set !== true,
    invited: isInvitee(user.user_metadata),
  };
}

// Página de cada passo. app.html e admin.html são das Tasks 11 e 13.
export const STEP_PAGE: Record<Step, string> = {
  login: "login.html",
  "check-email": "signup.html#check-email",
  "set-password": "accept-invite.html",
  "mfa-enroll": "mfa.html",
  "mfa-challenge": "login.html",
  app: "app.html",
  admin: "admin.html",
};

export function goToStep(step: Step): void {
  location.replace(STEP_PAGE[step]);
}

// Chamada no início de cada página protegida: devolve true se o passo for o da página
// (ou um dos dela); senão redireciona e devolve false.
export async function requireStep(own: Step | readonly Step[]): Promise<{ ok: boolean; step: Step; state: AuthState }> {
  const state = await loadAuthState();
  const step = nextStep(state);
  if (stepAllowed(step, own)) return { ok: true, step, state };
  goToStep(step);
  return { ok: false, step, state };
}
